import {
  Component,
  ElementRef,
  forwardRef,
  ViewChild,
} from "@angular/core";
import {
  MapConfig,
  MapDataItem,
  StateService,
  Map,
  Legend,
  Tooltip,
} from "@dataunveil/ducharts";
import { UsMap } from '@dataunveil/ducharts'

import * as _ from "lodash";
import { debounceTime, Subscription } from "rxjs";
import configFactory, { ViewModeConfig, DEFAULT_CONFIGS } from './config'
import { TerritoryMapService } from './territory-map.service'
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ChartsModule } from "../../shared/charts/charts.module";
import { MatComponentsModule } from "src/app/mat-components.module";
import Widget from "../widget";
import { DataAggregationService, AggregationConfig } from 'src/app/services/data-aggregation.service';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    Map,
    UsMap,
    Legend,
    MatComponentsModule,
    Tooltip,
    FormsModule,
    forwardRef(() => ChartsModule),
  ],
  selector: "app-territory-map",
  templateUrl: "./territory-map.component.html",
  styleUrls: ["./territory-map.component.scss"],
  providers: [TerritoryMapService],
})
export class TerritoryMapComponent extends Widget {
  static override key = 100709;

  @ViewChild("TerritoryDiv", { static: true }) TerritoryDiv!: ElementRef;
  window: any = window;
  @ViewChild("fs") fs!: ElementRef;
  isActive = false;
  currentVisibleData: any = [];
  mapConfig!: MapConfig;

  selectedShowBy: any;
  selectedMapConfig: any;

  mapData: MapDataItem | any = [];
  heading: any;
  users: any;
  reqSubcription: Subscription[] = [];
  sourceName: any;
  noData: boolean = false;
  loader: boolean = true;
  formattedData: any = [];
  rightSideFlag = false;
  scorecardFlg = false;
  chartHeight:any;
  excelConfig: any[] = [];
  api_key: any;
  showLegendsLabel = false;
  Number = Number;
  
  // ─── State-Bubble legend ──────────────────────────────────
  bubbleLegend: { type: string; color: string }[] = []
  visibleBubbleTypes = new Set<string>()

  // ─── Config Sets ──────────────────────────────────────────
  savedConfigs: ViewModeConfig[] = []

  decryptedParams: any;
  clientKey: any;
  moduleKey: any;
  dashboardKey: any;

  private mapSelectionSub: Subscription | null = null;
  private pageDataSub: Subscription | null = null;
  private pageRawData: any[] = [];
  private staticDataReady: Promise<void> | null = null;
  private stateCodeToName: Record<string, string> = {};
  label = 'Number of Patients';
  selectedStateData:any = [];
  selectedObject:any = [];
  mapselected:any;
  hasStartedLoading = false;
  apiList = [
    { api_key: 100276 },
    { api_key: 100277 },
    { api_key: 100278 },
    { api_key: 100279 },
  ];

  override screenChange() {
    super.screenChange();
    if (!this.mapConfig?.view) return;

    const offset = Number(this.item?.config?.['fullscreenOffset']) || 60;
    const defaultHeight = Number(this.item?.config?.['chart_height']) || 500;
    const nextHeight = this.isFullscreen ? window.innerHeight - offset : defaultHeight;

    // Snapshot the current config, then unmount duc-us-map (*ngIf="mapConfig")
    // so its canvas, projection, zoom transform, and lasso bindings rebuild
    // against the new container size. Mutating view.height in place leaves the
    // chart's internal state tied to the old dimensions, which is what makes
    // the lasso flaky after toggling fullscreen.
    const previousConfig = this.mapConfig;
    if (this.mapSelectionSub) {
      this.mapSelectionSub.unsubscribe();
      this.mapSelectionSub = null;
    }
    this.mapConfig = undefined as any;

    setTimeout(() => {
      this.mapConfig = {
        ...previousConfig,
        view: {
          ...previousConfig.view,
          height: nextHeight,
        },
      };
      setTimeout(() => this.subscribeToMapSelection(), 100);
    }, 0);
  }

  constructor(
    protected stateService: StateService,
    private mapService: TerritoryMapService,
    private dataAggregation: DataAggregationService
  ) {
    super();
    this.route.params.subscribe((p: any) => {
      this.route.queryParams.subscribe((params: any) => {
        this.decryptedParams = this.navigationService.decryptData(params);
        this.clientKey = this.decryptedParams["cl_key"];
        this.moduleKey = this.decryptedParams["md_key"];
        this.dashboardKey = this.decryptedParams["ds_key"];
      });
    });

  }

  // ─── Lifecycle ────────────────────────────────────────────

  override ngOnInit() {
    const observer = new ResizeObserver((entries: any) => {
      setTimeout(() => {
        this.onSizeChange.emit(entries[0].contentRect.height);
      }, 0);
    });
    observer.observe(this.el?.nativeElement);
// debugger
    // Load static assets (topology + zip-fips) via service
    this.staticDataReady = this.mapService.loadStaticData().then(() => {
      const geometries = this.mapService.topology?.objects?.states?.geometries || [];
      this.stateCodeToName = geometries.reduce((acc: Record<string, string>, g: any) => {
        const abbr = g?.properties?.abbr;
        const name = g?.properties?.name;
        if (abbr && name) acc[abbr] = name;
        return acc;
      }, {});
    });

    this.resolveSelectedMapConfig();

    let cfg = this.item?.config;
    this.rightSideFlag = cfg?.["rightside_expension_flag"]?.["value"] == 'no' ? false : true;
    this.scorecardFlg = cfg?.["scoreCard_btm_flg"]?.["value"] == 'yes' ? true : false;
    this.chartHeight = cfg?.["chart_height"] || 500;
    this.excelConfig = cfg?.['excel_column']?.['columns'] || [];

    this.subscribeToMapSelection();

    this.reqSubcription.push(
      this.filterService.filterQuery.subscribe((query: any) => {
        // debugger
        // if (!this.pageDataService?.isActive) {
          this.loader = true;
          this.mapselected = null;
          this.mapConfig = undefined as any;
          this.mapData = [] as any;
          this.mapService.clearCache();
          if (this.pageDataService?.isActive) return;
          // this.resolveSelectedMapConfig();
          this.loadApiData();
        // }
      }),
    );
    this.reqSubcription.push(
      this.filterService.triggerNestedQuery.pipe(debounceTime(2000)).subscribe((query: any) => {
        if (query !== this.item?.["widget_uniq_key"]) return;
        this.mapselected = null;

        
        this.loader = true;
        this.mapConfig = undefined as any;
        this.mapData = [] as any;
        this.mapService.clearCache();
        
        // Page mode: toggle just changed pageChangeDisplays — re-filter the
        // cached raw data and rebuild without firing another API call.
        if (this.pageDataService?.isActive) {
          this.rebuildFromPageData();
          return;
        }

        this.loadApiData();
      }),
    );

    // if (!this.filterService.isEmptyObject(this.filterService.baseQuery)) {
    //   this.loader = true;
    //   this.loadApiData();
    // }

    // Page-level data mode — subscribe to shared data stream ONCE.
    // All later toggle / filter / show-by changes reuse this stream to avoid
    // stacking duplicate subscriptions.
    if (this.pageDataService?.isActive) {

      // Page mode: data comes from centralized PageDataService.
      // Stay in loading state until the page service has actually started a load —
      // otherwise the BehaviorSubject's initial empty emission would flip the loader off.

      this.subs.push(
        this.pageDataService.loading$.subscribe(loading => {
          if (loading) {
            this.loader = true;
            this.mapConfig = undefined as any;
            this.mapData = [] as any;
            this.mapService.clearCache();
          }
        })
      );

      const listOfApi = this.item?.config?.['list_of_api'];
      const apiKey = listOfApi?.api_key ?? listOfApi ?? 300550;
      const stream$ = apiKey
        ? this.pageDataService.getDataStream(String(apiKey))
        : this.pageDataService.getCommonDataStream();

      this.pageDataSub = stream$.subscribe((res: any) => {

        if(this.filterService.isEmptyObject(this.filterService.baseQuery) == true)return;
        
        this.pageRawData = res || [];
        if (res && res.length > 0) {
          if (this.pageDataService) this.pageDataService.toggleData = [...res];
          this.data = this.pageDataService?.filterPageData(res) || [];
          this.buildView();
        } else {
          // BehaviorSubject replays its current value (often `[]`) immediately
          // on subscribe, so we cannot treat an empty emission as "load done".
          // Leave loader on; the loading$ subscription above will turn it off
          // once the fetch actually completes.
          this.loader = false;
          this.data = [];
          if (this.pageDataService) this.pageDataService.toggleData = [];
          this.error_name = '';
        }
      });
      this.subs.push(this.pageDataSub);
    }
  }

  // ─── Resolve selected map config ──────────────────────────

  private resolveSelectedMapConfig() {
    this.savedConfigs = this.item?.config?.['map_config'] || [];
    const widgetKey = this.item?.["widget_uniq_key"] || this.item?.key || 'default';
    this.selectedShowBy = this.filterService.getShowByMapSelection(widgetKey) ?? this.savedConfigs?.[0]?.id;
    this.selectedMapConfig = this.savedConfigs.find((f: any) => f.id == this.selectedShowBy) || this.savedConfigs?.[0];
    if (this.selectedMapConfig) {
      this.config = configFactory(this.selectedMapConfig);
    }
  }

  // ─── Select config from dropdown / show-by ────────────────

  selectConfig(id: string) {
    this.selectedShowBy = id
    this.selectedMapConfig = this.savedConfigs.find(c => c.id === id) || this.savedConfigs[0]
    // sessionStorage.setItem('territory-map-configs:active', id)
    this.config = configFactory(this.selectedMapConfig)

    this.loader = true;
    this.mapConfig = undefined as any
    this.mapData = [] as any
    this.mapService.clearCache()
    
    // Page mode: reuse cached page data, no API call needed.
    if (this.pageDataService?.isActive) {
      this.rebuildFromPageData();
      return;
    }
    this.loadApiData()
  }

  // Re-filter the most recently received page-level data through
  // filterPageData (which respects the latest pageChangeDisplays toggle) and
  // rebuild the view in place. No API call, no stacked subscriptions.
  private rebuildFromPageData() {
    if (this.pageRawData?.length) {
      this.data = this.pageDataService?.filterPageData(this.pageRawData) || [];
      this.buildView();
    } else {   
      if(!this.hasStartedLoading) {
        this.hasStartedLoading = true;
        return;
      }
      this.loader = false;
      this.data = [];
      this.error_name = '';
    }
  }

  // ─── Data API Call ────────────────────────────────────────

  loadApiData() {
    // Page mode is handled by the single stream subscription set up in
    // ngOnInit — never refetch from here.
    if (this.pageDataService?.isActive) return;

    const cfg = this.selectedMapConfig
    if (!cfg?.list_of_api || this.filterService.isEmptyObject(this.filterService.baseQuery)) return

    let obj = { api_key: cfg.list_of_api };
    let query = Object.assign({}, this.filterService.baseQuery, obj);
    query["report_typ"] = this.filterService.report_type || 'D';
    query["module_key"] = this.apiService.getModuleKey();

    let endPoint = this.item.config?.["list_of_api_endpoint"];

    this.subs.push(
      this.httpClient
        .post(
          `${this.apiService.apiBaseUrl}/${endPoint || "kpi/get-execution-details"}`,
          query,
        )
        .subscribe(
          async (res: any) => {

            if(this.pageDataService?.isActive) {
              this.pageDataService.toggleData = [...res];
              res = this.pageDataService?.filterPageData(res) || [];
            } 

            this.data = res.length > 0 ? res : [];
            if (this.staticDataReady) await this.staticDataReady;
            this.buildView();
          },
          (err: any) => {
            this.loader = false;
            this.noData = true;
            this.data = [];
            if (this.pageDataService) this.pageDataService.toggleData = [];
            this.error_name =
              err?.error?.error?.message ||
              err?.error?.message ||
              err?.message ||
              "";
          },
        ),
    );
  }

  getAvgBusinessHours(rows: any[], cfg: any) {
    const config: AggregationConfig = {
      groupBy:cfg['aggregation_groupBy'] ||'period',
      fields:cfg['aggregation_fields']||{
        total_bi_requests:   { source: 'total_bi_requests', op: 'sum' },
      },
      computed: cfg['aggregation_computed'] || { },
    };
    console.log(`Territory Map Props:${cfg.heading}`,config);
    const result = this.dataAggregation.aggregate(rows, config);
    return { groups: result.groups, summary: result.summary };
  }

  // ─── Build View (matches lib pattern) ─────────────────────

  private async buildView() {
    // Ensure topology + fipsByZip have loaded — UsMap crashes on undefined topology.
    if (this.staticDataReady) await this.staticDataReady;
    if (!this.mapService.topology) {
      this.loader = false;
      return;
    }

    const cffg = this.item?.config;
    if(cffg?.['AggregationEnabled'] == true){
      const { groups, summary } = this.getAvgBusinessHours(this.data, cffg);
      this.data = groups;
      // console.log('Territory Map Avg Business Hours Data', this.data, summary);
    }

    const cfg = this.selectedMapConfig

    if (this.rightSideFlag) {
      this.users = this.callApis(this.apiList);
    }

    function compareState(a: any, b: any) {
      return (a / 1000 | 0) === (b / 1000 | 0)
    }

    this.mapConfig = {
      id: this.config.components[0].id,
      view: {
        height: Number(this.chartHeight) || null,
        counties: cfg?.counties,
        ...this.config.components[0].view,
        topology: this.mapService.topology,
        cities: this.mapService.cities,
        citiesZoom: 10,
        projection: 'albersUsa',
        areas: ['nation', 'states', 'counties'],
        detailsByZoom: [{
          range: [0.8, 1.99],
          type: 'areaLabel',
          name: 'states',
          field: 'abbr',
        }, {
          range: [2, 8],
          type: 'areaLabel',
          name: 'states',
          field: 'name',
        }, {
          range: [0.8, 20],
          type: 'area',
          name: 'counties',
        }, {
          range: [18, 20],
          type: 'areaLabel',
          name: 'counties',
          field: 'name',
        }],
        areasFilter: [, (a: any, b: any) => a !== b, (a: any, b: any) => a !== b && compareState(a.id, b.id)],
        mode: cfg.mode,
        colorBar: cfg.colorBar?.length ? cfg.colorBar : undefined,
        colorTypes: cfg.colorTypes?.length ? cfg.colorTypes : undefined,
        highlight: cfg.highlight || 'counties',
        showLabels: cfg.mode !== 'state-badge',
        showSubLabels: cfg.showSubLabels || false,
        showSubLabelName: cfg.showSubLabelName || 'sites',
        badgeBg: cfg?.badgeBg || "#fff",
        badgeTextColor: cfg?.badgeTextColor || "#000",
        borders: {
          nation: { color: '#8A98AB', width: .5 },
          states: { color: '#8A98AB', width: 1 },
          counties: { color: '#e1eeff', width: 0.8 },
          highlight: { color: '#2e58c170', width: 0, level: 'states' as const },
          selected: { color: '#FFCD4A', width: 3, level: 'states' as const },
        },
      }
    } as any;
// debugger
    // Use the service to format data based on config mode
    const result = this.mapService.buildDataForConfig(cfg, this.data)
    this.mapData = result.data

    // if (result.min != null) this.min = result.min
    // if (result.max != null) this.max = result.max

    if (result.max === 0 && this.mapConfig?.view) {
      (this.mapConfig as any).view.colorBar = ['#CEE3FF', '#CEE3FF', '#CEE3FF']
    }

    if (cfg.mode === 'state-bubble') {
      this.bubbleLegend = cfg.colorTypes.map((entry: any) => {
        const key = Object.keys(entry).find(k => k !== 'flag')!
        return { type: key, color: entry[key] }
      })
      this.visibleBubbleTypes = new Set(this.bubbleLegend.map(e => e.type))
    } else {
      this.bubbleLegend = []
      this.visibleBubbleTypes = new Set()
    }

    this.loader = false;
    this.error_name = "";

    // Re-subscribe after map is rendered
    setTimeout(() => {
      this.subscribeToMapSelection();
    }, 100);
  }

  // ─── Show-by handler (from icon-chart) ────────────────────

  showBySubs(event: any) {
    if (this.mapSelectionSub) {
      this.mapSelectionSub.unsubscribe();
      this.mapSelectionSub = null;
    }

    // for Slope chart
    this.selectedObject = [];
    this.selectedStateData = [];
    this.mapselected = null;

    // icon-chart emits { widget, value, item } — extract the config id
    const configId = typeof event === 'string' ? event : event?.value ?? event;
    const targetConfig = this.savedConfigs.find(c => c.id === configId) || this.savedConfigs[0];
    if (targetConfig) {
      this.selectedShowBy = targetConfig.id;
      this.selectedMapConfig = this.savedConfigs.find((f: any) => f.id == targetConfig.id) || this.savedConfigs[0];
      this.selectConfig(targetConfig.id);
    }
  }

  // ─── Range Bar Hover ──────────────────────────────────────

  onRangeBarHover($event: any) {
    this.stateService.set('range-static-legend', { event: $event });
  }

  showTopIdns() {
  }

  // ─── Map Selection Subscription ───────────────────────────

  private subscribeToMapSelection() {
    if (this.mapSelectionSub) {
      this.mapSelectionSub.unsubscribe();
      this.mapSelectionSub = null;
    }

    this.mapSelectionSub = this.stateService.get(this.config.components[0].id, 'selected')
      .subscribe((state: any) => {
        // debugger
        if (state && state.selected && this.selectedMapConfig?.id == "state-icon-view") {
          const selectedArr: any[] = Array.isArray(state.selected) ? state.selected : [state.selected];
          const groupedRecords: any[] = selectedArr.flatMap((item: any) => item?.data?.grouped || item?.grouped || (item?.data ? [item.data] : []));
          if (groupedRecords.length) {
            const sumBy = (key: string) => groupedRecords.reduce((acc: Record<string, number>, r: any) => {
              const k = r?.[key];
              if (!k) return acc;
              acc[k] = (acc[k] || 0) + (Number(r.canceled_patient_count) || 0);
              return acc;
            }, {});
            const pickTop = (counts: Record<string, number>) =>
              Object.entries(counts).sort(([, a], [, b]) => b - a)[0]?.[0];

            // const stateCode = groupedRecords[0]?.state || undefined;
            this.selectedObject = [
              {
                key: 'Total Cancelled',
                value: groupedRecords.reduce((sum: number, r: any) => sum + (Number(r.canceled_patient_count) || 0), 0)
              },
              {
                key: 'Top Reason',
                value: pickTop(sumBy('catgry_name'))
              },
              {
                key: 'Under Performing IDN',
                value: pickTop(sumBy('source_name'))
              }
            ];
            this.selectedStateData = [...groupedRecords] // this.data.filter((f:any) => f.state_cd === stateCode);
          } else {
            this.selectedObject = [
              {
                key: 'Total Cancelled',
                value: 0
              },
              {
                key: 'Top Reason',
                value: '-'
              },
              {
                key: 'Under Performing IDN',
                value: '-'
              }
            ];
            this.selectedStateData = [];
          }
          this.mapselected = 'state';
        } else if (state && state.selected && this.selectedMapConfig?.slopeChartTrigger === true) {
          const selectedArr: any[] = Array.isArray(state.selected) ? state.selected : [state.selected];
          const groupedRecords: any[] = selectedArr.flatMap((item: any) => item?.data?.grouped || item?.grouped || []);
          if (groupedRecords.length) {
            const sumBy = (key: string) => groupedRecords.reduce((acc: Record<string, number>, r: any) => {
              const k = r?.[key];
              if (!k) return acc;
              acc[k] = (acc[k] || 0) + (Number(r.canceled_patient_count) || 0);
              return acc;
            }, {});
            const pickTop = (counts: Record<string, number>) =>
              Object.entries(counts).sort(([, a], [, b]) => b - a)[0]?.[0];

            const stateCode = state.selected?.state || groupedRecords[0]?.state || undefined;
            this.selectedObject = [
              {
                key: 'Selected State',
                value: stateCode ? (this.stateCodeToName[stateCode] || stateCode) : undefined,
              },
              {
                key: 'Total Cancelled',
                value: groupedRecords.reduce((sum: number, r: any) => sum + (Number(r.canceled_patient_count) || 0), 0)
              },
              {
                key: 'Top Reason',
                value: pickTop(sumBy('catgry_name'))
              },
              {
                key: 'Under Performing IDN',
                value: pickTop(sumBy('source_name'))
              }
            ];

            this.selectedStateData = this.data.filter((f:any) => f.state_cd === stateCode);

            // this.filterService.slopeChartSelection.next(obj);
          } else {
            const stateCode = state.selected?.state || groupedRecords[0]?.state || undefined;
            this.selectedObject = [
              {
                key: 'Selected State',
                value: stateCode ? (this.stateCodeToName[stateCode] || stateCode) : '-',
              },
              {
                key: 'Total Cancelled',
                value: '-'
              },
              {
                key: 'Top Reason',
                value: '-'
              },
              {
                key: 'Under Performing IDN',
                value: '-'
              }
            ];
            this.selectedStateData = [];  
          }
          this.mapselected = 'state';
        } else {
          this.selectedObject = [];
          this.selectedStateData = [];

          if (state && state?.selected && state.selected?.length && state.selected?.length > 0) {
            const oracle_account_ids = [...new Set(state.selected.map((item: any) => item['data'].oracle_account_id).filter(Boolean))].join(',');
            const states = [...new Set(state.selected.map((item: any) => item['data'].state).filter(Boolean))].join(',');
            let obj = {
              oracle_account_id: oracle_account_ids || undefined,
              state_cd: states || undefined
            };
            this.filterService.chroplethMapSelection.next(obj);
          } else {
            let json: any = this.filterService.previousSelectedItems;
            const result = json['state_cd']?.map((item: any) => item['state_cd']).join(',');
            let state_cd = state?.selected?.state || result || undefined;
            this.mapselected = state_cd;

            if (!state_cd) return;
            let obj = { state_cd: state_cd };
            this.filterService.chroplethMapSelection.next(obj);
          }
        }

        setTimeout(() => {
          const scrollContainer = document.getElementById('gridViewscrollbar');
          if (scrollContainer) {
            const lastElement = scrollContainer.querySelector(':scope > *:last-child');
            if (lastElement) {
              lastElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
            }
          } else {
            const scorecardSection = document.getElementById('scorecardSection');
            if (scorecardSection) {
              scorecardSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }
        }, 100);
      });
  }

  // ─── Right Side Panel APIs ────────────────────────────────

  callApis(apiList: any[]) {
    const apiCalls = apiList.map((api: any) => {
      const obj = { api_key: api.api_key };
      const query = Object.assign({}, this.filterService.baseQuery, obj);
      query["report_typ"] = this.filterService.report_type;
      return this.httpClient
        .post(`${this.apiService.apiBaseUrl}/${this.apiService.executionUrl}`, query)
        .toPromise();
    });

    Promise.all(apiCalls)
      .then((responses: any) => {
        this.formattedData = [
          {
            id: 1,
            name: "New accounts",
            count: responses[0].length,
            type: "followUp",
            data: responses[0].map((item: any, index: any) => ({
              id: index + 1,
              follow: false,
              name: "New accounts",
              username: item.hco_name,
              address: item.address,
              phone: "",
              website: "",
              company: { name: "", catchPhrase: "", bs: "" },
            })),
          },
          {
            id: 2,
            name: "Highest volume",
            count: "Top " + responses[1].length,
            type: "progressBar",
            data: responses[1].map((item: any, index: any) => ({
              id: index + 1,
              follow: false,
              username: item.hco_name,
              volume: item.volume,
            })),
          },
          {
            id: 3,
            name: "Most lagging patients",
            count: responses[2].length,
            type: "progressBarnumber",
            data: responses[2].map((item: any, index: any) => ({
              id: index + 1,
              follow: false,
              username: item.hco_name,
              volume: item.lagging_patients,
            })),
          },
          {
            id: 4,
            name: "Longest time to conversion",
            count: responses[3].length,
            type: "progressBardays",
            data: responses[3].map((item: any, index: any) => ({
              id: index + 1,
              follow: false,
              username: item.hco_name,
              volume: item.longest_time_to_conversion,
            })),
          },
        ];
        this.users = this.formattedData;
      })
      .catch((error) => {
        console.error("API call error:", error);
        this.noData = true;
      });
  }

  // ─── Helpers ──────────────────────────────────────────────

  transform(value: number): string {
    if (value >= 1000) {
      const suffixes = ["", "K", "M", "B", "T"];
      const suffixNum = Math.floor(("" + value).length / 3);
      const shortValue = parseFloat(
        (suffixNum !== 0 ? value / Math.pow(1000, suffixNum) : value).toPrecision(2),
      );
      return shortValue + suffixes[suffixNum];
    }
    return value.toString();
  }

  calculatePercentage(part: number, total: any[]): number {
    const maxTotal = _.maxBy(total, "volume");
    const maxVolume = maxTotal ? maxTotal.volume : 0;
    if (maxVolume === 0) return 0;
    return (part / maxVolume) * 100;
  }

  togglePracticeType(type: string) {
    // debugger  
    if (this.visibleBubbleTypes.has(type)) {
      this.visibleBubbleTypes.delete(type)
    } else {
      this.visibleBubbleTypes.add(type)
    }
    this.chartService.set('bubble-practice-filter', { event: new Set(this.visibleBubbleTypes) })
  }

  override ngOnDestroy(): void {
    this.reqSubcription.forEach((res) => res.unsubscribe());
  }

  // ─── Cleanup ──────────────────────────────────────────────
  slopeItem = {
    "x": 0,
    "y": 0,
    "cols": 50,
    "rows": 8,
    "key": "100609",
    "config": {
        "widgetKey": "100609",
        "widget_nm": "Slope Chart",
        "report_heading": "SP Performance",
        "divid": "",
        "chart_type": "scorecard",
        "prop_list_of_api": "",
        "comment_type": "",
        "show_data_point": {
            "name": "false",
            "value": "false"
        },
        "static_plot": {
            "name": "false",
            "value": "false"
        },
        "data_point": "",
        "zoom_slider_left": {
            "name": "false",
            "value": "false"
        },
        "zoom_slider_right": {
            "name": "false",
            "value": "false"
        },
        "link_name1": "",
        "link_name2": "",
        "height_configuration": {
            "name": "Dynamic",
            "value": "dynamic"
        },
        "time_cycle": "",
        "default_timeCycle": "",
        "widget_header_config": [
            {
                "name": "Page Header",
                "value": "page_header",
                "add_header": true,
                "searchByKey": [
                    {
                        "value": "ALL",
                        "name": "All Columns",
                        "param": "search_val"
                    },
                    {
                        "value": "PI",
                        "name": "Patient ID",
                        "param": "patient_id"
                    },
                    {
                        "value": "PH",
                        "name": "PHI Columns",
                        "param": "search_val"
                    }
                ],
                "header_name_isNeed": true,
                "page_header_name": "IDN Breakdown"
            },
            {
                "name": "Hidden Toggle",
                "value": "hidden_toggle"
            },
            {
                "name": "Analytical Mode",
                "value": "analytical_mode"
            },
            {
                "name": "Slider",
                "value": "slider"
            },
            {
                "name": "Range Legend Bar",
                "value": "range_bar"
            },
            {
                "name": "Selection Toggle",
                "value": "selection_toggle",
                "add_header": false,
                "searchByKey": [
                    {
                        "value": "ALL",
                        "name": "All Columns",
                        "param": "search_val"
                    },
                    {
                        "value": "PI",
                        "name": "Patient ID",
                        "param": "patient_id"
                    },
                    {
                        "value": "PH",
                        "name": "PHI Columns",
                        "param": "search_val"
                    }
                ],
                "selection_toggle": false,
                "toggle_btn": [
                    {
                        "title": "SP",
                        "value": "0"
                    },
                    {
                        "title": "IDN",
                        "value": "1"
                    }
                ],
                "groupby_page_level": "idn_sp_indicator"
            },
            {
                "name": "Moving Average",
                "value": "moving_average"
            },
            {
                "name": "Search Box",
                "value": "search_box"
            },
            {
                "name": "Legands",
                "value": "legends"
            },
            {
                "name": "Annotation",
                "value": "annotation"
            },
            {
                "name": "Alerts",
                "value": "alerts"
            },
            {
                "name": "Change Status",
                "value": "change_status"
            },
            {
                "name": "Time Cycle",
                "value": "time_cycle"
            },
            {
                "name": "Status Label in Network",
                "value": "status_label"
            },
            {
                "name": "Static legends Territory Map",
                "value": "legends_territory_map"
            },
            {
                "name": "Map - Show By",
                "value": "map_show_by"
            },
            {
                "name": "Pagination",
                "value": "page_size"
            },
            {
                "name": "Sort By",
                "value": "sort_by"
            },
            {
                "name": "Follow Up",
                "value": "follow_up"
            },
            {
                "name": "Show By",
                "value": "show_by"
            },
            {
                "name": "Icons On Right side",
                "value": "icons",
                "iconList": [
                    {
                        "name": "info_circle",
                        "value": "info_circle.svg",
                        "activated": false
                    },
                    {
                        "name": "tabular_circle",
                        "value": "tabular_circle.svg",
                        "activated": false
                    },
                    {
                        "name": "expand_circle",
                        "value": "expand_circle.svg",
                        "activated": false
                    },
                    {
                        "name": "dotmenu_circle",
                        "value": "dotmenu_circle.svg",
                        "activated": false,
                        "is_Event": false,
                        "event": [
                            {
                                "name": "PDF Chart",
                                "value": "pdf"
                            },
                            {
                                "name": "PDF Table",
                                "value": "pdftable"
                            },
                            {
                                "name": "Excel",
                                "value": "excel",
                                "is_true": true,
                                "dispPlayName": "Export to Excel"
                            },
                            {
                                "name": "Server Side Excel",
                                "value": "serverexcel"
                            },
                            {
                                "name": "API Export Excel",
                                "value": "apiexcel"
                            },
                            {
                                "name": "CSV",
                                "value": "csv"
                            },
                            {
                                "name": "PNG",
                                "value": "png",
                                "is_true": true,
                                "dispPlayName": "Export to Image"
                            },
                            {
                                "name": "Test",
                                "value": "test"
                            }
                        ]
                    },
                    {
                        "name": "union_circle",
                        "value": "union_circle.svg"
                    },
                    {
                        "name": "gridload_circle",
                        "value": "gridload_circle.svg"
                    },
                    {
                        "name": "setting",
                        "value": "setting.svg"
                    },
                    {
                        "name": "compare",
                        "value": "compare.svg"
                    },
                    {
                        "name": "change_status",
                        "value": "change_status.svg"
                    },
                    {
                        "name": "layout",
                        "value": "layout.svg"
                    },
                    {
                        "name": "shuffle",
                        "value": "shuffle.svg"
                    },
                    {
                        "name": "notes",
                        "value": "notes.svg"
                    },
                    {
                        "name": "sort",
                        "value": "sort.svg"
                    },
                    {
                        "name": "fire",
                        "value": "fire.svg"
                    },
                    {
                        "name": "select_setting",
                        "value": "select_setting.svg"
                    },
                    {
                        "name": "preference_settings",
                        "value": "pre_setting.svg"
                    },
                    {
                        "name": "manage_statusBtn",
                        "value": "manage_statusBtn.svg"
                    }
                ],
                "add_header": true,
                "searchByKey": [
                    {
                        "value": "ALL",
                        "name": "All Columns",
                        "param": "search_val"
                    },
                    {
                        "value": "PI",
                        "name": "Patient ID",
                        "param": "patient_id"
                    },
                    {
                        "value": "PH",
                        "name": "PHI Columns",
                        "param": "search_val"
                    }
                ],
                "icon_selected": true
            }
        ],
        "list_of_api1": "",
        "list_of_api_col": "",
        "x_axis": "",
        "y_axis": "",
        "value_column": "",
        "list_of_api_col_2": "",
        "excel_heading": "",
        "excel_column": "",
        "AggregationEnabled": true,
        "aggregation_groupBy": "source_name,catgry_name",
        "aggregation_fields": {
            "canceled_patient_count": {
                "source": "canceled_patient_count",
                "op": "sum"
            },
            "total_cancelled": {
                "source": "total_cancelled",
                "op": "sum"
            }
        },
        "aggregation_computed": {
            "pct_cancelled": {
                "op": "percent",
                "numerator": "canceled_patient_count",
                "denominator": "total_cancelled",
                "round": 5
            }
        },
        "aggregation_timeSeries": "",
        "list_of_api_endpoint": "PSS/get-pss-data",
        "lineVar": "source_name",
        "kpiVar": "catgry_name",
        "valueVar": "canceled_patient_count",
        "groupVar": "",
        "formatVar": "",
        "rangeVars_start": "",
        "rangeVars_end": "",
        "column_fields_config": {
            "HCP Cancellation": {
              "kpi_format": ".0%"
            },
            "Insurance Denial": {
              "kpi_format": ".0%"
            },
            "Patient Abandonment": {
              "kpi_format": ".0%"
            },
            "Transfer": {
              "kpi_format": ".0%"
            },
            "Other": {
                "kpi_format": ".0%"
            }
        },
        "data_mode": "page",
        "list_of_api": {
            "api_key": 200344,
            "api_widget_typ": "Charts",
            "api_nm": "percentage_cancelled_patients_page",
            "api_display_nm": "% of Cancelled Patients - Page Level",
            "api_end_point": "PSS/get-pss-data"
        }
    },
    "widget_uniq_key": "100807_20260417150849"
  }
}
